var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ConfirmationDialog2", { ref: "confirmationDialog" }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: _vm.$vuetify.breakpoint.smAndDown,
            persistent: "",
            "content-class": "save-query-dialog",
            "max-width": "600px",
          },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _vm.dialog
            ? _c("div", { staticClass: "save-dialog" }, [
                _c(
                  "div",
                  { staticClass: "save-dialog-head" },
                  [
                    _c("h2", { staticClass: "save-dialog-title" }, [
                      _vm._v("Save query"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "save-dialog-x",
                        attrs: {
                          icon: "",
                          small: "",
                          disabled: _vm.loading.saving,
                          "aria-label": "Close save query dialog",
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.close()
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v("close"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "save-dialog-content" },
                  [
                    _vm.nameCheckError
                      ? _c(
                          "div",
                          {
                            staticClass: "save-state save-state-warning",
                            attrs: { role: "status", "aria-live": "polite" },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.nameCheckError) +
                                "\n        "
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "save-state",
                            class: { "save-state-warning": _vm.isDestructive },
                            attrs: { role: "status", "aria-live": "polite" },
                          },
                          [
                            _vm.loading.name
                              ? _c("span", [
                                  _vm._v("Checking for an existing query…"),
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.saveStateMessage)),
                                ]),
                          ]
                        ),
                    _vm._v(" "),
                    _c("Form", {
                      ref: "form",
                      attrs: { disabled: _vm.loading.saving },
                      on: {
                        "update:formData": function ($event) {
                          _vm.formData = $event
                        },
                        "update:isValid": function ($event) {
                          _vm.isValid = $event
                        },
                        "update:selectedUser": function ($event) {
                          _vm.selectedUser = $event
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "save-dialog-foot" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "save-dialog-feedback",
                        attrs: { "aria-live": "polite" },
                      },
                      [_vm._v(_vm._s(_vm.feedbackText))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "save-dialog-spacer" }),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "save-submit",
                        class: { "save-submit-warning": _vm.isDestructive },
                        attrs: {
                          depressed: "",
                          loading: _vm.loading.saving,
                          disabled: _vm.submitDisabled,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.submit()
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { small: "", left: "" } }, [
                          _vm._v("save"),
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.submitLabel) +
                            "\n        "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "save-cancel",
                        attrs: { outlined: "", disabled: _vm.loading.saving },
                        on: {
                          click: function ($event) {
                            return _vm.close()
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { small: "", left: "" } }, [
                          _vm._v("close"),
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("Button.Cancel")) +
                            "\n        "
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }